import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { TranslationModule } from '@hdms/shared/feature';
import { HeaderMetaNavModule, HeaderUIUserModule } from '@hdms/shared/page-frame/ui';
import { ButtonModule, FlyoutModule, MobileModalWindowModule, SvgIconModule } from '@hdms/shared/ui-core';
import { AnalyticsModule } from '@hdms/shared/util-core';

import { HeaderUserPopoverComponent } from './header-user-popover.component';

@NgModule({
  declarations: [HeaderUserPopoverComponent],
  imports: [
    CommonModule,
    ButtonModule,
    FlyoutModule,
    NgbPopoverModule,
    MobileModalWindowModule,
    HeaderUIUserModule,
    SvgIconModule,
    TranslationModule,
    HeaderMetaNavModule,
    AnalyticsModule
  ],
  exports: [HeaderUserPopoverComponent]
})
export class HeaderUserPopoverModule {}
